import React, { useState } from 'react';

function FacebookComment({ handleChangeFacebookComments, maxComments }) {
    const [formValues, setFormValues] = useState([{ name: "" }])

    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i][e.target.name] = e.target.value;
        setFormValues(newFormValues);
        handleChangeFacebookComments(Array.prototype.map.call(formValues, function (item) { return item.name; }).join(","))
    }

    let addFormFields = () => {
        if (maxComments > formValues?.length) {
            setFormValues([...formValues, { name: "" }])
        }
    }

    let removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }

    return (
        <div className="flex flex-col my-10 py-5 px-5 lg:px-20 border border-gray-350 rounded-3xl  "> 
        <label className="uppercase font-semibold self-center"> Please enter your comments. {formValues.length} / {maxComments}</label>
            <form className='flex flex-col  content-center items-center max-h-screen overflow-y-auto scrollbar'>
               
                {formValues.map((element, index) => (
                    <div className="flex flex-col" key={index}>
                        <label className="font-semibold py-5">Comment: {index + 1}</label>

                        <div className='flex flex-row'>
                            <textarea className='transition ease-in-out hover:border-b-pink-500 hover:border-b-2 h-20 w-48 lg:h-36 lg:w-96 bg-gray-50 rounded-md outline-0 border border-transparent' type="text" name="name" placeholder="Type your comment" value={element.name || ""} onChange={e => handleChange(index, e)} />
                            <div className='w-16 h-16'>
                                {
                                    index ?
                                        <button type="button" className="button remove mx-3 my-0 px-3 py-1 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all" onClick={() => removeFormFields(index)}>X</button>
                                        : null
                                }</div>
                        </div>
                    </div>
                ))}  
                </form>
                <div className=" self-center button-section py-5">
                    <button className="my-3 px-10 py-3 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all" type="button" onClick={() => addFormFields()}>Add Comment</button>
                </div>
          
        </div>
    )
}

export default FacebookComment